/* Sound / genre chapter bar as a fixed bottom bar (sections/ls-sound-subnav.liquid, position "bottom").
 * Same behaviour as the event page bar: slides in once the section's spot has scrolled above the screen, marks the
 * link of the section in view, hides while a dialog / scroll lock or the phone keyboard is open, pads body by --ls-dock-h. */
(() => {
  const dock = document.querySelector('[data-snd-dock]:not([data-dock-ready])');
  if (!dock) return;
  dock.dataset.dockReady = '1';
  const spot = document.querySelector('[data-snd-dock-spot]');
  const row = dock.querySelector('.ls-chapter-links');
  const links = [...dock.querySelectorAll('.ls-chapter-links a[href^="#"]')];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  links.forEach((a) => {
    if (!document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)))) a.hidden = true;
  });
  const shown = () => links.filter((a) => !a.hidden);
  const target = (a) => document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));

  let pastHero = dock.dataset.show === 'always' || dock.hasAttribute('data-design-mode') || !spot;
  let keyboardOpen = false;
  const locked = () => {
    const html = document.documentElement;
    return html.style.overflow === 'hidden' || document.body.style.overflow === 'hidden'
      || html.classList.contains('prevent-scroll') || html.classList.contains('ls-scroll-lock')
      || Boolean(document.querySelector('dialog[open]'));
  };
  const render = () => {
    const visible = pastHero && !keyboardOpen && !locked();
    dock.toggleAttribute('data-visible', visible);
    dock.inert = !visible;
    const h = visible ? dock.offsetHeight + 'px' : '0px';
    if (document.body.style.getPropertyValue('--ls-dock-h') !== h) document.body.style.setProperty('--ls-dock-h', h);
  };

  if (spot && !pastHero) {
    new IntersectionObserver(([entry]) => {
      pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      render();
    }).observe(spot);
  }
  new MutationObserver(render).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
  new MutationObserver(render).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('close', () => setTimeout(render), true);
  document.addEventListener('toggle', () => setTimeout(render), true);
  if (window.visualViewport) {
    const onViewport = () => {
      const field = document.activeElement;
      const typing = field && field.matches('input:not([type=radio]):not([type=checkbox]), textarea, select, [contenteditable]');
      keyboardOpen = Boolean(typing) && window.visualViewport.height < window.innerHeight * 0.75;
      render();
    };
    window.visualViewport.addEventListener('resize', onViewport);
    document.addEventListener('focusout', () => setTimeout(onViewport, 50));
  }
  if ('ResizeObserver' in window) new ResizeObserver(render).observe(dock);

  let current = null;
  let raf = 0;
  const spy = () => {
    raf = 0;
    const line = window.innerHeight * 0.35;
    let next = null;
    shown().forEach((a) => {
      const t = target(a);
      if (t && t.getBoundingClientRect().top <= line) next = a;
    });
    if (!next) next = shown()[0] || null;
    if (next === current) return;
    current = next;
    links.forEach((a) => {
      if (a === current) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
    if (current && row && row.scrollWidth > row.clientWidth + 1) {
      const r = current.getBoundingClientRect();
      const left = row.scrollLeft + r.left - row.getBoundingClientRect().left - (row.clientWidth - r.width) / 2;
      row.scrollTo({ left: Math.max(0, left), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
  };
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(spy); }, { passive: true });
  window.addEventListener('resize', () => { if (!raf) raf = requestAnimationFrame(spy); }, { passive: true });
  links.forEach((a) => a.addEventListener('click', () => {
    const t = target(a);
    if (!t) return;
    if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
    setTimeout(() => t.focus({ preventScroll: true }), 60);
  }));
  spy();
  render();
})();
